<template>
  <li class="mega-menu__menu-item mega-menu__menu-item--depth-1"
    :class="menuOpen ? 'mega-menu__menu-item--depth-1--open' : ''">
    <template v-if="itemIsDefined(item, 'childMenu')"> 
      <button class="mega-menu__link mega-menu__button mega-menu__link--depth-1"
        @click="toggleMenu">{{ item.label }}</button>
      <div class="mega-menu__container">
        <div class="mega-menu__scroll-container">
          <div class="mega-menu__container--depth-2">
            <a v-if="itemIsDefined(item, 'link.title')"
              :href="getLink(item.link)">
              <h4 class="mega-menu--depth-1__title">{{ item.link.title }}</h4>
            </a>
            <button class="mega-menu--close" @click="closeMegaMenu">
              <font-awesome-icon icon="times"/>
            </button>
            <ul class="mega-menu--depth-2">
              <mega-menu-level-2 v-for="(itemDepth1, index) in item.childMenu"
                :itemDepth1="itemDepth1"
                :key="`mega-menu-2-${index}`" />
            </ul>
            <div class="mega-menu__menu-highlights">
              <div class="mega-menu__menu-highlights-item" v-for="highlightedItem in item.image">
                <a v-if="itemIsDefined(highlightedItem, 'image.file.url')"
                  :href="getLink(highlightedItem.link)">
                  <img class="highlight-img" :src="highlightedItem.image.file.url">
                </a>
                <a v-if="itemIsDefined(highlightedItem, 'link.title')"
                  :href="getLink(highlightedItem.link)">
                  <h4 class="highlight-title">{{ highlightedItem.link.title }}</h4>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <a v-else-if="itemIsDefined(item, 'link.title')"
      :href="getLink(item.link)"
      class="mega-menu__link mega-menu__link--depth-1">{{ item.link.title }}</a>
  </li>
</template>

<script>
import MegaMenuLevel2 from "@/components/layout/header/MegaMenu/MegaMenuLevel2"
import mainSite from "@/util/mainSite"

export default {
  name: "mega-menu-level-1",
  components: {
    MegaMenuLevel2
  },
  mixins: [mainSite],
  props: {
    item: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      menuOpen: false
    }
  },
  methods: {
    closeMegaMenu() {
      this.menuOpen = false;
      body.classList.remove('body--locked');
    },
    async toggleMenu() {
      if(!this.menuOpen) {
        // Let other MegaMenu items know of a change; will call closeMegaMenu();
        await this.$emit('menuChange');
        this.menuOpen = true
      } else {
        this.menuOpen = false
      }

      const body = document.getElementById('body');

      if(this.menuOpen) {
        body.classList.add('body--locked');
      } else {
        body.classList.remove('body--locked');
      }
    }
  },
}
</script>

<style>

</style>